export default function getDialogData (i18n) {
  return {
    common: {
      error: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.common.title'),
        description: i18n.t('dialog.common.desc')
      }
    },
    dashboard: {
      // todo: hongseok: check description
      deleteApply: {
        type: 'confirm',
        iconClass: 'icon--dialog-trash',
        title: i18n.t('dialog.dashboard.deleteApply.title'),
        description: i18n.t('dialog.dashboard.deleteApply.desc')
      },
      editLimited: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        titleClass: 'warning',
        title: i18n.t('dialog.dashboard.editLimited.title'),
        description: i18n.t('dialog.dashboard.editLimited.desc')
      },
      editCancel: {
        type: 'confirm',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.dashboard.editCancel.title'),
        description: i18n.t('dialog.dashboard.editCancel.desc')
      },
      saveApplies: {
        type: 'confirm',
        iconClass: 'icon--dialog-confirm',
        title: i18n.t('dialog.dashboard.saveApplies.title'),
        description: i18n.t('dialog.dashboard.saveApplies.desc')
      },
      trackingCodeInstalled: {
        type: 'alert',
        iconClass: 'icon--dialog-confirm',
        description: i18n.t('dialog.dashboard.trackingCodeInstalled.desc')
      },
      trackingCodeNotInstalled: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        description: i18n.t('dialog.dashboard.trackingCodeNotInstalled.desc')
      },
      trackingCodeLoginPage: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        description: i18n.t('dialog.dashboard.trackingCodeLoginPage.desc')
      },
      trackingCodeNetworkingError: {
        type: 'alert',
        iconClass: 'icon--dialog-network',
        description: i18n.t('dialog.dashboard.trackingCodeNetworkingError.desc')
      },
      trackingCodeCheckFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        description: i18n.t('dialog.dashboard.trackingCodeCheckFailed.desc')
      }
    },
    userInfo: {
      myInformationEditSuccess: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.userInfo.myInformationEditSuccess.title'),
        description: i18n.t('dialog.userInfo.myInformationEditSuccess.desc')
      },
      ipBlockItemDelete: {
        type: 'confirm',
        iconClass: 'icon--dialog-warning',
        description: i18n.t('dialog.userInfo.ipBlockItemDelete.desc')
      },
      ipBlockConfirmEdit: {
        type: 'confirm',
        iconClass: 'icon--dialog-confirm',
        title: i18n.t('dialog.userInfo.ipBlockConfirmEdit.title'),
        description: i18n.t('dialog.userInfo.ipBlockConfirmEdit.desc')
      }
    },
    plan: {
      cancelSubscriptionFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.cancelSubscriptionFailed.title'),
        description: i18n.t('dialog.plan.cancelSubscriptionFailed.desc')
      },
      updateFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.updateFailed.title'),
        description: i18n.t('dialog.plan.updateFailed.desc')
      },
      registerCardFailed: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.registerCardFailed.title'),
        description: i18n.t('dialog.plan.registerCardFailed.desc')
      },
      pvEmpty: {
        type: 'confirm',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.plan.pvEmpty.title'),
        description: i18n.t('dialog.plan.pvEmpty.desc')
      },
      completed: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.plan.completed.title'),
        description: i18n.t('dialog.plan.completed.desc')
      },
      applicationCompleted: {
        type: 'alert',
        iconClass: 'icon--check-green-size50',
        title: i18n.t('dialog.plan.applicationCompleted.title'),
        description: i18n.t('dialog.plan.applicationCompleted.desc')
      }
    },
    abReport: {
      pageList: {
        notExistingAvailableTraffic: {
          type: 'alert',
          iconClass: 'icon--dialog-warning',
          description: i18n.t('dialog.abReport.pageList.notExistingAvailableTraffic.desc')
        }
      }
    },
    page: {
      customTracking: {
        type: 'alert',
        iconClass: 'icon--pause',
        title: i18n.t('dialog.page.customTracking.title'),
        description: i18n.t('dialog.page.customTracking.desc')
      }
    },
    report: {
      invalidRequest: {
        type: 'alert',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.report.invalidRequest.title'),
        description: i18n.t('dialog.report.invalidRequest.desc')
      },
      changePeriodResetUtm: {
        type: 'confirm',
        iconClass: 'icon--dialog-warning',
        title: i18n.t('dialog.campaignTargeting.changePeriodResetUtm.title'),
        description: i18n.t('dialog.campaignTargeting.changePeriodResetUtm.desc')
      }
    }
  }
}
